module.exports = __webpack_public_path__ + "static/media/edit-blue.5e0ba5b6.svg";